<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">总账</span>
		</div>
		<div class="margin-right-left margin-top">
			<div class="book-toolbar">
				<div class="book-toolbar-main">
					<div class="book-toolbar-period">
						<account-date-choose v-model="periodRange" :range="true"/>
					</div>
					<div class="book-toolbar-actions">
						<Button type="primary" @click="exportData">导出</Button>
						<Checkbox v-if="amountMode === 'base'" v-model="showNumPrice" class="book-inline-checkbox">显示数量金额</Checkbox>
					</div>
				</div>
				<div class="book-toolbar-filters">
					<div class="book-filter-group">
						<label class="book-filter-label">金额方式</label>
						<Select
							v-model="amountMode"
							:datas="amountModeOptions"
							keyName="key"
							titleName="title"
							:deletable="false"
							class="book-filter-select mode-select"
						/>
					</div>
					<div class="book-filter-group" v-if="amountMode === 'foreign'">
						<label class="book-filter-label">币种</label>
						<template v-if="!noForeignCurrency">
							<Select
								v-model="currencyCode"
								:datas="currencyOptions"
								keyName="key"
								titleName="title"
								filterable
								:deletable="false"
								class="book-filter-select currency-select"
							/>
						</template>
						<span v-else class="book-filter-hint">当前账套无可用外币，请先配置外币</span>
					</div>
				</div>
			</div>
		</div>
		<div class="h-panel-body margin" :space-x="10" style="overflow-x: auto;padding: 0;">
			<Loading text="总账数据加载中..." :loading="loading"></Loading>

			<!-- 本币模式 - 普通表格 -->
			<table class="summary" v-if="amountMode === 'base' && !showNumPrice">
				<tr class="header bg-primary-color white-color">
					<td>科目编码</td>
					<td>科目名称</td>
					<td>期间</td>
					<td>摘要</td>
					<td>借方金额</td>
					<td>贷方金额</td>
					<td>方向</td>
					<td>余额</td>
				</tr>
				<template v-for="item in datalist">
					<tr class="bg-gray3-color">
						<td colspan="8">
							<span @click="toggleSummary(item)" class="text-hover">
								<i class="fa fa-caret-down" :class="{'fa-caret-right':item._expand}"></i>
								<span class="primary-color font-bold"> {{item.subject.name}}</span>
							</span>
						</td>
					</tr>
					<tr v-if="!item._expand" class="summary" v-for="s in item.summary">
						<td>{{item.subject.code}}</td>
						<td>{{item.subject.name}}</td>
						<td>{{s.voucherDate|fqFormat}}</td>
						<td>{{s.summary}}</td>
						<td align="right">{{s.debitAmount|numFormat}}</td>
						<td align="right">{{s.creditAmount|numFormat}}</td>
						<td align="center">{{s.balanceDirection}}</td>
						<td align="right">{{s.balance|numFormat}}</td>
					</tr>
				</template>
				<tr v-if="!datalist.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
			</table>

			<!-- 本币模式 - 数量金额表格 -->
			<table v-if="amountMode === 'base' && showNumPrice" class="cus-table" style="width: 1780px;">
				<thead class="header">
				<tr>
					<td rowspan="2" width="100">科目编码</td>
					<td rowspan="2" width="100">科目名称</td>
					<td rowspan="2" width="80">单位</td>
					<td colspan="4">期初余额</td>
					<td colspan="2">本期借方</td>
					<td colspan="2">本期贷方</td>
					<td colspan="2">本年累计借方</td>
					<td colspan="2">本年累计贷方</td>
					<td colspan="4">期末余额</td>
				</tr>
				<tr>
					<td width="100">方向</td>
					<td width="100">数量</td>
					<td width="100">单价</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">方向</td>
					<td width="100">数量</td>
					<td width="100">单价</td>
					<td width="100">金额</td>
				</tr>
				</thead>
				<tr v-for="{subject,summary} in datalist" :key="subject.id">
					<td>{{subject.code}}</td>
					<td>{{subject.name}}</td>
					<td class="text-center">{{subject.unit}}</td>
					<td class="text-center">{{summary[0].balanceDirection}}</td>
					<td class="text-right">{{summary[0].num}}</td>
					<td class="text-right">{{summary[0].price|numFormat}}</td>
					<td class="text-right">{{summary[0].balance|numFormat}}</td>
					<td class="text-right">{{summary[1].debitAmount ? summary[1].num:''}}</td>
					<td class="text-right">{{summary[1].debitAmount|numFormat}}</td>
					<td class="text-right">{{summary[1].creditAmount ? summary[1].num:''}}</td>
					<td class="text-right">{{summary[1].creditAmount|numFormat}}</td>
					<td class="text-right">{{summary[2].debitAmount ? summary[2].num:''}}</td>
					<td class="text-right">{{summary[2].debitAmount|numFormat}}</td>
					<td class="text-right">{{summary[2].creditAmount ? summary[2].num:''}}</td>
					<td class="text-right">{{summary[2].creditAmount|numFormat}}</td>
					<td class="text-center">{{summary[3] ? summary[3].balanceDirection : ''}}</td>
					<td class="text-right">{{summary[3] ? (summary[3].numBalance || summary[3].num) : ''}}</td>
					<td class="text-right">{{formatSummaryNumber(summary[3], 'price')}}</td>
					<td class="text-right">{{formatSummaryNumber(summary[3], 'balance')}}</td>
				</tr>
			</table>

			<!-- 外币模式表格 -->
			<table class="summary foreign-table" v-if="amountMode === 'foreign'" style="width:1400px;">
				<thead>
				<tr class="header bg-primary-color white-color">
					<td width="90">科目编码</td>
					<td width="120">科目名称</td>
					<td width="80">币种</td>
					<td width="80">摘要</td>
					<td width="120">原币借方</td>
					<td width="120">原币贷方</td>
					<td width="120">原币余额</td>
					<td width="120">本币借方</td>
					<td width="120">本币贷方</td>
					<td width="60">方向</td>
					<td width="120">本币余额</td>
				</tr>
				</thead>
				<tbody>
				<template v-for="item in datalist">
					<!-- 科目分组折叠行 -->
					<tr class="subject-group-row bg-gray3-color">
						<td colspan="11">
							<span @click="toggleSummary(item)" class="text-hover">
								<i class="fa fa-caret-down" :class="{'fa-caret-right':item._expand}"></i>
								<span class="primary-color font-bold">{{item.subject.code}} {{item.subject.name}}</span>
							</span>
						</td>
					</tr>
					<template v-if="!item._expand">
						<template v-for="cur in item.currencies">
							<!-- 币种子标题行 -->
							<tr class="currency-group-row">
								<td colspan="11">
									<span class="currency-badge">{{cur.currencyCode}}</span>
									<span style="margin-left:4px;color:#555;">{{cur.currencyName}}</span>
								</td>
							</tr>
							<!-- 4条汇总行：期初、本期、本年、期末 -->
							<tr class="summary foreign-summary-row" v-for="s in cur.summary" :key="s.summary">
								<td>{{item.subject.code}}</td>
								<td>{{item.subject.name}}</td>
								<td class="text-center">
									<span class="currency-badge">{{cur.currencyCode}}</span>
								</td>
								<td>{{s.summary}}</td>
								<!-- 原币借方：期初/期末无意义，留空 -->
								<td class="text-right">{{formatOrigin(s.originalDebitAmount)}}</td>
								<!-- 原币贷方 -->
								<td class="text-right">{{formatOrigin(s.originalCreditAmount)}}</td>
								<!-- 原币余额：仅期初/期末有值 -->
								<td class="text-right">{{formatOrigin(s.originalBalance)}}</td>
								<!-- 本币借方 -->
								<td class="text-right">{{formatBase(s.debitAmount)}}</td>
								<!-- 本币贷方 -->
								<td class="text-right">{{formatBase(s.creditAmount)}}</td>
								<!-- 方向：仅期初/期末行有 -->
								<td class="text-center">{{s.balanceDirection || ''}}</td>
								<!-- 本币余额：仅期初/期末行有 -->
								<td class="text-right">{{formatBase(s.balance)}}</td>
							</tr>
						</template>
					</template>
				</template>
				<tr v-if="!datalist.length">
					<td colspan="11" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	import accountBookPeriodRange from '@/mixins/accountBookPeriodRange'

	export default {
		name: 'GeneralLedger',
		mixins: [accountBookPeriodRange],
		data() {
			return {
				loading: false,
				periodRange: {
					startDate: null,
					endDate: null
				},
				showNumPrice: false,
				numPriceDisabled: true,
				amountMode: 'base',
				currencyCode: '',
				currencyList: [],
				noForeignCurrency: false,    // 是否没有任何非本位币
				datalist: []
			};
		},
		computed: {
			amountModeOptions() {
				return [
					{key: 'base', title: '本币金额方式'},
					{key: 'foreign', title: '外币金额方式'}
				];
			},
			currencyOptions() {
				const baseCurrency = this.getBaseCurrency;
				const filtered = (this.currencyList || []).filter(item => !item.localCurrency);
				if (filtered.length === 0) {
					return [];
				}
				return filtered.map(item => ({
					key: item.code,
					title: `${item.code} - ${item.name || item.code}`
				}));
			},
			getBaseCurrency() {
				const list = this.currencyList || [];
				const base = list.find(item => item.localCurrency);
				return base ? base.code : '';
			},
		},
		watch: {
			periodRange: {
				handler() {
					if (!this.accountBookPeriodRangeReady) {
						return;
					}
					this.loadList();
				},
				deep: true
			},
			showNumPrice() {
				this.loadList();
			},
			amountMode(newVal) {
				if (newVal === 'foreign') {
					const baseCurrency = this.getBaseCurrency;
					const foreignCurrencies = (this.currencyList || []).filter(item => !item.localCurrency);
					if (foreignCurrencies.length === 0) {
						this.noForeignCurrency = true;
						this.currencyCode = '';
						this.datalist = [];
						return;
					}
					this.noForeignCurrency = false;
					const validCodes = foreignCurrencies.map(c => c.code);
					if (!this.currencyCode || !validCodes.includes(this.currencyCode)) {
						this.currencyCode = foreignCurrencies[0].code;
					}
					this.loadList();
				} else {
					this.noForeignCurrency = false;
					this.currencyCode = '';
					this.datalist = [];
					this.loadList();
				}
			},
			currencyCode() {
				if (this.amountMode === 'foreign') {
					this.loadList();
				}
			}
		},
		methods: {
			onAccountBookPeriodRangeReady() {
				this.loadCurrencyList();
				this.loadList();
			},
			buildRangeParams() {
				return {
					startDate: this.periodRange.startDate,
					endDate: this.periodRange.endDate
				};
			},
			loadCurrencyList() {
				if (this.$api.setting && this.$api.setting.currency) {
					this.$api.setting.currency.list().then(({data}) => {
						this.currencyList = Array.isArray(data) ? data : (data.data || []);
					}).catch(() => {});
				}
			},
			loadList() {
				this.loading = true;
				const params = {
					...this.buildRangeParams(),
					showNumPrice: this.showNumPrice,
					amountMode: this.amountMode,
					currencyCode: this.amountMode === 'foreign' ? (this.currencyCode || '') : undefined
				};
				this.$api.accountbook.loadGeneralLedger(params).then(({data}) => {
					this.datalist = data;
					this.loading = false;
				});
			},
			toggleSummary(item) {
				this.$set(item, '_expand', !item._expand)
			},
			formatSummaryNumber(item, key) {
				if (!item || item[key] === null || item[key] === undefined || item[key] === '') {
					return '';
				}
				return this.$options.filters.numFormat(item[key]);
			},
			formatOrigin(val) {
				if (val === null || val === undefined) return '';
				if (Math.abs(val) < 0.001) return '';
				return this.$options.filters.numFormat(val);
			},
			formatBase(val) {
				if (val === null || val === undefined) return '';
				return this.$options.filters.numFormat(val);
			},
			exportData() {
				const params = {
					...this.buildRangeParams(),
					showNumPrice: this.showNumPrice,
					amountMode: this.amountMode,
					currencyCode: this.amountMode === 'foreign' ? (this.currencyCode || '') : ''
				};
				window.open(`/api/accountbook/export/generalLedger?${new URLSearchParams(params).toString()}`);
			}
		}
	};
</script>

<style scoped lang="less">
	.book-toolbar {
		padding: 14px 16px;
		background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);
		border: 1px solid #dbe7f3;
		border-radius: 10px;
		box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
	}

	.book-toolbar-main {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 12px;
	}

	.book-toolbar-period {
		flex: 1 1 320px;
		min-width: 280px;
	}

	.book-toolbar-actions {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;
		justify-content: flex-end;
	}

	.book-toolbar-filters {
		margin-top: 12px;
		padding-top: 12px;
		border-top: 1px dashed #d7e2ee;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 16px;
	}

	.book-filter-group {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.book-filter-label {
		font-size: 13px;
		color: #516173;
		font-weight: 600;
		white-space: nowrap;
	}

	.book-inline-checkbox {
		white-space: nowrap;
	}

	.book-filter-select {
		min-width: 180px;
	}

	.currency-select {
		min-width: 220px;
	}

	.summary {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #eee;
			font-size: 12px;
			height: 32px;
		}

		.summary:nth-child(even) {
			background-color: #f8fbf8;
		}

		.summary:hover {
			background-color: #dff7df;
		}

		.header {
			td {
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}

	.foreign-table {
		.subject-group-row td {
			padding: 4px 8px;
			font-size: 13px;
		}

		.currency-group-row td {
			background-color: #f0f5ff;
			padding: 3px 8px;
			font-size: 12px;
			border-bottom: 1px solid #d0dff0;
		}

		.foreign-summary-row:nth-child(even) {
			background-color: #fafcff;
		}

		.foreign-summary-row:hover {
			background-color: #e8f0ff;
		}
	}

	.currency-badge {
		display: inline-block;
		background-color: #e8f0fe;
		color: #1a56db;
		border-radius: 3px;
		padding: 0 5px;
		font-size: 11px;
		font-weight: bold;
		border: 1px solid #c3d4f8;
	}

	.book-filter-hint {
		color: #999;
		font-size: 12px;
		font-style: italic;
	}
	@media (max-width: 1200px) {
		.book-toolbar-actions {
			justify-content: flex-start;
		}
	}
</style>
